import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flights" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Red = _resolveComponent("Red")!
  const _component_Green = _resolveComponent("Green")!
  const _component_Yellow = _resolveComponent("Yellow")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, "Date"),
        _createElementVNode("th", null, "Time"),
        _createElementVNode("th", null, "Flight Number"),
        _createElementVNode("th", null, "Direction"),
        _createElementVNode("th", null, "Pad"),
        _createElementVNode("th", null, "Status")
      ])
    ], -1)),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flights, (flight) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: flight.date,
          class: _normalizeClass({ blink: flight.offStation() })
        }, [
          _createElementVNode("td", null, _toDisplayString(_ctx.date(flight)), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.time()), 1),
          _createElementVNode("td", null, _toDisplayString(flight.number()), 1),
          _createElementVNode("td", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flight.direction(), (part, index) => {
              return (_openBlock(), _createElementBlock("span", { key: part }, [
                part
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(part), 1))
                  : (_openBlock(), _createBlock(_component_Red, { key: 1 }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode("REDACTED")
                      ])),
                      _: 1,
                      __: [0]
                    })),
                (index !== flight.direction().length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("td", null, _toDisplayString(flight.pad()), 1),
          _createElementVNode("td", null, [
            (_ctx.arrivals && flight.statusArrivalScheduled())
              ? (_openBlock(), _createBlock(_component_Green, { key: 0 }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" SCHEDULED ")
                  ])),
                  _: 1,
                  __: [1]
                }))
              : _createCommentVNode("", true),
            (_ctx.arrivals && flight.statusArrived())
              ? (_openBlock(), _createBlock(_component_Red, { key: 1 }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" ARRIVED ")
                  ])),
                  _: 1,
                  __: [2]
                }))
              : _createCommentVNode("", true),
            (_ctx.arrivals && flight.statusArriving())
              ? (_openBlock(), _createBlock(_component_Yellow, { key: 2 }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" ARRIVING ")
                  ])),
                  _: 1,
                  __: [3]
                }))
              : _createCommentVNode("", true),
            (!_ctx.arrivals && flight.statusDepartureScheduled())
              ? (_openBlock(), _createBlock(_component_Green, { key: 3 }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" SCHEDULED ")
                  ])),
                  _: 1,
                  __: [4]
                }))
              : _createCommentVNode("", true),
            (!_ctx.arrivals && flight.statusDeparted())
              ? (_openBlock(), _createBlock(_component_Red, { key: 4 }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" DEPARTED ")
                  ])),
                  _: 1,
                  __: [5]
                }))
              : _createCommentVNode("", true),
            (!_ctx.arrivals && flight.statusDeparting())
              ? (_openBlock(), _createBlock(_component_Yellow, { key: 5 }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" DEPARTING ")
                  ])),
                  _: 1,
                  __: [6]
                }))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128))
    ])
  ]))
}